import Vue from 'vue'
import Router from 'vue-router'
import Carousel from '@/components/Carousel'
import Homepage from '@/components/Homepage'
import Search from '@/components/Search'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
      {name: 'intro', path: '/', component: Carousel},
      {name: 'homepage', path: '/home', component: Homepage},
      {name: 'search', path: '/search', component: Search},
      {name: 'the-magic', path: '/:filter', component: Carousel},
      {name: 'master-pieces', path: '/:filter', component: Carousel},
      {name: 'dioramas', path: '/:filter', component: Carousel},
      {name: 'manufacturers', path: '/:filter', component: Carousel},
      {name: 'materials', path: '/:filter', component: Carousel},
      {name: 'boxes-and-scales', path: '/:filter', component: Carousel},
      {name: 'model-history', path: '/:filter', component: Carousel}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js